import CartesianExamples from './Cartesian';
import ScatterPlotExamples from './ScatterPlot';
import BarChartExamples from './Bar';
import PieExamples from './Pie';
import GaugeExamples from './Gauge';
import HeatMapExamples from './HeatMap';
import HeatGridExamples from './HeatGrid';

export default [
  ...CartesianExamples,
  ...ScatterPlotExamples,
  ...BarChartExamples,
  ...PieExamples,
  ...GaugeExamples,
  ...HeatMapExamples,
  ...HeatGridExamples,
];
